import { render, staticRenderFns } from "./Transition.vue?vue&type=template&id=b566d68c&scoped=true&"
import script from "./Transition.vue?vue&type=script&lang=js&"
export * from "./Transition.vue?vue&type=script&lang=js&"
import style0 from "./Transition.vue?vue&type=style&index=0&id=b566d68c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b566d68c",
  null
  
)

export default component.exports